import * as React from 'react';
import * as _ from 'lodash';
import { Link } from 'react-router';
import * as helpers from '../../utilities/helpers';
import { MessageBox } from '../../components/PageLayout/Popups/MessageBox';
import { PARTS } from './../../schemas/accessRightsModel';
import { ProjectScopeIcons as iconOptions } from '../../components/ProjectScope/NewFeatureGroup';
export default function (props, context) {
    function onClick1(featureGroup, groupName, canEnableFeaturesGroups, activeQtCategoryIndex, MsgBoxTitle, enabled, visible, className, disabledClass, AR) {
        this.setState({ editingImageUrl: false });
    }
    function onClick2(featureGroup, groupName, canEnableFeaturesGroups, activeQtCategoryIndex, MsgBoxTitle, enabled, visible, className, disabledClass, AR) {
        this.setState({ editingImageUrl: false });
    }
    function onClick3(featureGroup, groupName, canEnableFeaturesGroups, activeQtCategoryIndex, MsgBoxTitle, enabled, visible, className, disabledClass, AR, option, optionIndex) {
        this.stopEdit('ImageUrl', option);
    }
    function repeatOption4(featureGroup, groupName, canEnableFeaturesGroups, activeQtCategoryIndex, MsgBoxTitle, enabled, visible, className, disabledClass, AR, option, optionIndex) {
        return [React.createElement('div', {
                'className': 'pj-scope-new-icon-library-option ' + (this.isSelectedImage(option) ? 'selected' : ''),
                'style': { backgroundImage: 'url(/content/views/dashboard/images/icons/pj-scope-icons/enabled/' + option + ')' },
                'onClick': onClick3.bind(this, featureGroup, groupName, canEnableFeaturesGroups, activeQtCategoryIndex, MsgBoxTitle, enabled, visible, className, disabledClass, AR, option, optionIndex),
                'key': '14961'
            })];
    }
    function onClick5(featureGroup, groupName, canEnableFeaturesGroups, activeQtCategoryIndex, MsgBoxTitle, enabled, visible, className, disabledClass, AR) {
        canEnableFeaturesGroups && this.onChangeVisible(!visible);
    }
    function onClick6(featureGroup, groupName, canEnableFeaturesGroups, activeQtCategoryIndex, MsgBoxTitle, enabled, visible, className, disabledClass, AR) {
        this.props.removeFeatureGroupFromCategory(featureGroup);
    }
    function onClick7(featureGroup, groupName, canEnableFeaturesGroups, activeQtCategoryIndex, MsgBoxTitle, enabled, visible, className, disabledClass, AR) {
        {
            this.setState({ showInformation: true });
        }
    }
    function onClick8(featureGroup, groupName, canEnableFeaturesGroups, activeQtCategoryIndex, MsgBoxTitle, enabled, visible, className, disabledClass, AR) {
        canEnableFeaturesGroups && this.onChangeEnabled(!enabled);
    }
    function onClick9(featureGroup, groupName, canEnableFeaturesGroups, activeQtCategoryIndex, MsgBoxTitle, enabled, visible, className, disabledClass, AR) {
        this.startEdit('DisplayName');
    }
    function onChange10(featureGroup, groupName, canEnableFeaturesGroups, activeQtCategoryIndex, MsgBoxTitle, enabled, visible, className, disabledClass, AR, e) {
        this.setState({ customDisplayName: e.target.value });
    }
    function onKeyPress11(featureGroup, groupName, canEnableFeaturesGroups, activeQtCategoryIndex, MsgBoxTitle, enabled, visible, className, disabledClass, AR, e) {
        e.key === 'Enter' && this.stopEdit('DisplayName', this.state.customDisplayName);
    }
    function onBlur12(featureGroup, groupName, canEnableFeaturesGroups, activeQtCategoryIndex, MsgBoxTitle, enabled, visible, className, disabledClass, AR, e) {
        this.stopEdit('DisplayName', e.target.value);
    }
    function onClick13(featureGroup, groupName, canEnableFeaturesGroups, activeQtCategoryIndex, MsgBoxTitle, enabled, visible, className, disabledClass, AR) {
        this.editImageClick();
    }
    function onClick14(featureGroup, groupName, canEnableFeaturesGroups, activeQtCategoryIndex, MsgBoxTitle, enabled, visible, className, disabledClass, AR) {
        this.startEdit('Description');
    }
    function onChange15(featureGroup, groupName, canEnableFeaturesGroups, activeQtCategoryIndex, MsgBoxTitle, enabled, visible, className, disabledClass, AR, e) {
        this.setState({ customDescription: e.target.value });
    }
    function onKeyPress16(featureGroup, groupName, canEnableFeaturesGroups, activeQtCategoryIndex, MsgBoxTitle, enabled, visible, className, disabledClass, AR, e) {
        return e.key === 'Enter' && !e.shiftKey && this.stopEdit('Description', this.state.customDescription);
    }
    function onBlur17(featureGroup, groupName, canEnableFeaturesGroups, activeQtCategoryIndex, MsgBoxTitle, enabled, visible, className, disabledClass, AR, e) {
        this.stopEdit('Description', e.target.value);
    }
    function scopeFeatureGroupGroupNameCanEnableFeaturesGroupsActiveQtCategoryIndexMsgBoxTitleEnabledVisibleClassNameDisabledClassAR18() {
        var featureGroup = this.props.updatedFeatureGroup;
        var groupName = featureGroup.name;
        var canEnableFeaturesGroups = this.props.canEnableFeaturesGroups;
        var activeQtCategoryIndex = this.props.activeQtCategoryIndex;
        var MsgBoxTitle = 'Description of ' + featureGroup.name;
        var enabled = this.props.enabled;
        var visible = this.props.visible;
        var className = 'pj-scope-lir';
        var disabledClass = !enabled ? `${ className }-disabled` : '';
        var AR = this.props.AR;
        return React.createElement('div', {
            'className': 'pj-scope-lir ' + disabledClass,
            'key': '408'
        }, this.state.editingImageUrl ? React.createElement('div', {
            'className': 'pj-scope-new-icon-overlay',
            'onClick': onClick1.bind(this, featureGroup, groupName, canEnableFeaturesGroups, activeQtCategoryIndex, MsgBoxTitle, enabled, visible, className, disabledClass, AR),
            'key': '1015'
        }) : null, this.state.editingImageUrl ? React.createElement('div', {
            'className': 'pj-scope-new-icon-library',
            'key': '1155'
        }, React.createElement('div', { 'className': 'pj-scope-new-icon-library-header' }, '\r\n      Icon Library\r\n      ', React.createElement('div', {
            'className': 'pj-scope-new-icon-library-header-close',
            'onClick': onClick2.bind(this, featureGroup, groupName, canEnableFeaturesGroups, activeQtCategoryIndex, MsgBoxTitle, enabled, visible, className, disabledClass, AR)
        })), React.createElement.apply(this, [
            'div',
            { 'className': 'pj-scope-new-icon-library-options' },
            _.map(iconOptions, repeatOption4.bind(this, featureGroup, groupName, canEnableFeaturesGroups, activeQtCategoryIndex, MsgBoxTitle, enabled, visible, className, disabledClass, AR))
        ])) : null, React.createElement(MessageBox, {
            'visible': this.state.showInformation,
            'title': MsgBoxTitle,
            'message': this.state.customDescription,
            'type': 'system',
            'buttons': this.getInfoButton()
        }), React.createElement('i', {
            'className': 'pj-scope-eye-icon ' + `pj-scope-eye-icon-${ visible ? 'enabled-on' : 'disabled-off' }`,
            'onClick': onClick5.bind(this, featureGroup, groupName, canEnableFeaturesGroups, activeQtCategoryIndex, MsgBoxTitle, enabled, visible, className, disabledClass, AR)
        }), activeQtCategoryIndex ? React.createElement('i', {
            'onClick': onClick6.bind(this, featureGroup, groupName, canEnableFeaturesGroups, activeQtCategoryIndex, MsgBoxTitle, enabled, visible, className, disabledClass, AR),
            'className': 'pj-scope-lir-remove ui-icon-close ui-icon-close--red',
            'key': '2269'
        }) : null, React.createElement('i', {
            'className': 'pj-scope-more-info-icon ' + `pj-scope-more-info-icon-${ enabled ? 'enabled' : 'disabled' }`,
            'onClick': onClick7.bind(this, featureGroup, groupName, canEnableFeaturesGroups, activeQtCategoryIndex, MsgBoxTitle, enabled, visible, className, disabledClass, AR)
        }), React.createElement('div', { 'className': 'pj-scope-lir-enable-wrapper' }, React.createElement('div', {
            'className': 'pj-scope-lir-enable-radio ' + (!enabled ? 'pj-scope-lir-enable-radio-disabled' : ''),
            'onClick': onClick8.bind(this, featureGroup, groupName, canEnableFeaturesGroups, activeQtCategoryIndex, MsgBoxTitle, enabled, visible, className, disabledClass, AR)
        }, React.createElement('div', { 'className': 'pj-scope-lir-enable-radio2' }, enabled ? React.createElement('i', {
            'className': 'pj-scope-enable-checkmark',
            'key': '3207'
        }) : null, !enabled ? React.createElement('i', {
            'className': 'pj-scope-enable-dot',
            'key': '3271'
        }) : null)), React.createElement('div', { 'className': 'pj-scope-lir-enable-text ' + (!enabled ? 'pj-scope-lir-enable-text-disabled' : '') }, '\r\n      ', enabled ? 'Enabled' : 'Disabled', '\r\n    ')), React.createElement('div', { 'className': 'pj-scope-lir-innerline ' + (!enabled ? 'pj-scope-lir-innerline-disabled' : '') }), !this.state.editingDisplayName ? React.createElement('h1', {
            'className': 'pj-scope-lir-title',
            'onClick': onClick9.bind(this, featureGroup, groupName, canEnableFeaturesGroups, activeQtCategoryIndex, MsgBoxTitle, enabled, visible, className, disabledClass, AR),
            'key': '3610'
        }, '\r\n    ', this.state.customDisplayName || groupName, '\r\n  ') : null, this.state.editingDisplayName ? React.createElement('input', {
            'ref': node => {
                this.inputDisplayName = node;
            },
            'type': 'text',
            'className': 'pj-scope-lir-editing',
            'value': this.state.customDisplayName,
            'onChange': onChange10.bind(this, featureGroup, groupName, canEnableFeaturesGroups, activeQtCategoryIndex, MsgBoxTitle, enabled, visible, className, disabledClass, AR),
            'onKeyPress': onKeyPress11.bind(this, featureGroup, groupName, canEnableFeaturesGroups, activeQtCategoryIndex, MsgBoxTitle, enabled, visible, className, disabledClass, AR),
            'onBlur': onBlur12.bind(this, featureGroup, groupName, canEnableFeaturesGroups, activeQtCategoryIndex, MsgBoxTitle, enabled, visible, className, disabledClass, AR),
            'key': '3802'
        }) : null, React.createElement('div', {
            'className': 'pj-scope-lir-icon',
            'style': { backgroundImage: 'url(' + this.getImageUrl() + ')' }
        }), React.createElement('i', {
            'className': 'pj-scope-lir-icon-edit',
            'onClick': onClick13.bind(this, featureGroup, groupName, canEnableFeaturesGroups, activeQtCategoryIndex, MsgBoxTitle, enabled, visible, className, disabledClass, AR)
        }), !this.state.editingDescription ? React.createElement('p', {
            'onClick': onClick14.bind(this, featureGroup, groupName, canEnableFeaturesGroups, activeQtCategoryIndex, MsgBoxTitle, enabled, visible, className, disabledClass, AR),
            'className': 'pj-scope-lir-description',
            'key': '4438'
        }, '\r\n    ', this.state.customDescription || helpers.getFeatureGroupDescription(groupName), '\r\n  ') : null, this.state.editingDescription ? React.createElement('textarea', {
            'ref': node => {
                this.inputDescription = node;
            },
            'className': 'pj-scope-lir-editing',
            'value': this.state.customDescription,
            'onChange': onChange15.bind(this, featureGroup, groupName, canEnableFeaturesGroups, activeQtCategoryIndex, MsgBoxTitle, enabled, visible, className, disabledClass, AR),
            'onKeyPress': onKeyPress16.bind(this, featureGroup, groupName, canEnableFeaturesGroups, activeQtCategoryIndex, MsgBoxTitle, enabled, visible, className, disabledClass, AR),
            'onBlur': onBlur17.bind(this, featureGroup, groupName, canEnableFeaturesGroups, activeQtCategoryIndex, MsgBoxTitle, enabled, visible, className, disabledClass, AR),
            'key': '4668'
        }) : null, !this.props.isUnsaved ? React.createElement(Link, {
            'className': 'pj-scope-button-wrapper',
            'to': this.props.getFeatureCreatorLink(groupName),
            'key': '5126'
        }, React.createElement('button', { 'className': 'pj-scope-config-button ' + (!enabled ? 'pj-scope-config-button-disabled' : '') }, 'Configure')) : null, this.props.isUnsaved ? React.createElement('h3', { 'key': '5375' }, '\r\n    Save Changes to Configure\r\n  ') : null);
    }
    return this.props.updatedFeatureGroup.name !== 'No Feature' ? scopeFeatureGroupGroupNameCanEnableFeaturesGroupsActiveQtCategoryIndexMsgBoxTitleEnabledVisibleClassNameDisabledClassAR18.apply(this, []) : null;
}